import { render, staticRenderFns } from "./CategoryBanner.vue?vue&type=template&id=34052889"
import script from "./CategoryBanner.vue?vue&type=script&lang=ts"
export * from "./CategoryBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports